import NumberFormat from "react-number-format"
import { useSelector } from "react-redux"

export const SummaryGeneral = ({ form, handleAdd }) => {

    const pptoDetail = useSelector(state => state.ppto.detail)
    const {
        separacion_miles,
        separacion_decimales,
        simbolo,
        total_cliente,
        total_ingresos_proyectados,
        total_ingresos_por_proyectar,
       /*  total_facturado,
        total_por_facturar, */
        total_cobrado,
        total_por_cobrar,
        total_gasto_p,
        total_egresos_proyectados,
        total_egresos_por_proyectar,
       /*  total_gasto_r,
        total_por_gastar, */
        total_pagado,
        total_por_pagar
    } = pptoDetail

    return (
        <div className='grid grid-cols-2 justify-content-center align-items-center'>
            <div className="border-1 border-green-200 p-3 ms-3 rounded-xl bg-green-50">
                <h5 className="text-sm mb-2 font-medium">INGRESOS</h5>
                <div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Total Venta:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_cliente || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Total proyectado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_ingresos_proyectados || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Saldo por proyectar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_ingresos_por_proyectar || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>

                    {/* <div className='mt-1'>
                        <div>---</div>
                        <label style={{ fontWeight: 'bold' }}>Facturado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_facturado || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Por Facturar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_por_facturar || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div> */}

                    <div className='mt-1'>
                        <div>---</div>
                        <label style={{ fontWeight: 'bold' }}>Cobrado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_cobrado || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(con IGV)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Por cobrar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_por_cobrar || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(con IGV)</span>
                    </div>

                </div>
            </div>
            <div className="border-1 border-red-200 p-3 ms-3 rounded-xl bg-red-50 me-3" >
                <h5 className="text-sm mb-2 font-medium">EGRESOS</h5>
                <div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Total costos:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_gasto_p || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Total proyectado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_egresos_proyectados || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Saldo por proyectar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_egresos_por_proyectar || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>

                    {/* <div className='mt-1'>
                        <div>---</div>
                        <label style={{ fontWeight: 'bold' }}>Gastado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_gasto_r || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Por gastar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_por_gastar || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div> */}

                    <div className='mt-1'>
                        <div>---</div>
                        <label style={{ fontWeight: 'bold' }}>Pagado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_pagado || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(con IGV)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Por pagar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(total_por_pagar || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(con IGV)</span>
                    </div>

                </div>
                {/* <button
                    className="btn btn-link btn-sm p-mini-link p-fs-14"
                    onClick={() => handleAdd('egreso')}
                >
                    + Agregar flujo
                </button> */}
            </div>
        </div>
    )
}